import classNames from 'classnames';
import React from 'react';

type TextColors = 'primary' | 'secondary';
type Variant = 'h1' | 'h2' | 'h3' | 'p1' | 'p2' | 'p3' | 'l1' | 'l2' | 'l3';

type TypographyProps = React.HTMLAttributes<HTMLParagraphElement> & {
  variant?: Variant;
  color?: TextColors;
  light?: boolean;
};

const DARK_COLORS = {
  primary: '#FFFFFF',
  secondary: 'rgba(255, 255, 255, 0.6)',
};

const LIGHT_COLORS = {
  primary: '#070708',
  secondary: '#9194A1',
};

const WEIGHT = {
  h1: 'font-bold',
  h2: 'font-bold',
  h3: 'font-bold',
  p1: 'font-medium',
  p2: 'font-normal',
  p3: 'font-normal',
  l1: 'font-medium',
  l2: 'font-medium',
  l3: 'font-medium',
};

const SIZE = {
  h1: 'text-h1',
  h2: 'text-h2',
  h3: 'text-h3',
  p1: 'text-p1',
  p2: 'text-p2',
  p3: 'text-p3',
  l1: 'text-l1',
  l2: 'text-l2',
  l3: 'text-l3',
};

export default function Typography(props: TypographyProps) {
  const {
    children,
    className,
    variant = 'h2',
    color = 'primary',
    light = false,
    ...rest
  } = props;

  const fontColor = light ? LIGHT_COLORS[color] : DARK_COLORS[color];
  const Tag = variant.includes('h') ? 'h2' : 'p';

  return (
    <Tag
      style={{ color: fontColor }}
      className={classNames(
        `${WEIGHT[variant]}`,
        `${SIZE[variant]}`,
        className,
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
}
